import React, {useState, useEffect, useLayoutEffect, useRef} from 'react';
import './ret.css';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';
import {keepPreviousData, useQuery} from '@tanstack/react-query';

const Hizan =()=>{
    const jikap = useParams();
    const [pag, setpag] = useState({});
    const [addnum, setaddnum] = useState(1);
    const [single, setsingle] = useState(window.history?.ates?.page == undefined || window.history?.ates?.page == null ? 1 : window.history.ates.page);
    const [arum, setarum] = useState(window.history.state.molan == undefined || window.history.state.molan == null ? "allaround" : window.history.state.molan );
    

    const fnax = async (single, isMobile)=>{
        const {data} = await axios.get(`/api/frize?single=${single}&mdash=${isMobile}`);         
       
        return data;
    };

    const {isPending, data : last} = useQuery({queryKey:['event',single,isMobile], queryFn: ()=>fnax(single, isMobile), placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30});

    useLayoutEffect(()=>{
    const npnp = window.history?.ates?.nnnn == null || window.history?.ates?.nnnn == undefined ? 0 : parseInt(window.history.ates.nnnn);
    const apap = setTimeout(()=>{
        window.scrollTo(0,npnp);
    },1);
   
    document.title = "수상자 - 돌파공모";
    return ()=>{clearTimeout(apap);};
    
    }, []);
  
    const addnumber=()=>{
        setaddnum(addnum+1);
        setsingle(addnum*10+1);
    };

    const minusnumber=()=>{
        setaddnum(addnum-1);
        setsingle((addnum-1)*10);
    };
    
    const yidong=(cons)=>{
        setsingle(cons);
        const kogaki = document.getElementById("herija");
        kogaki.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };

    return(
        <>
        <p>명예로운 수상자</p>
        <p>실력 향상을 이뤄냈습니다!! 돌파 기록은 성취입니다!!</p>
        <p>돌파의 결실을 돌파공모에 남겨주세요</p>
        <div>
            <p>돌파공모는 여러분의 성취를 응원하며, 결코 포기하지 않고 도전을 즐기는 모습을 너무나도 환영합니다.</p>
            <p>자랑스러운 수상 이력은 도전의 부스터, 돌파를 향한 저력 넘치는 에너지로 우리를 추동합니다.</p>
            <p>적극적으로 도전하고, 그에 대한 성취 기록을 돌파공모인들에게 알려주세요!!</p>
            <p>공모전을 통해 우리 모두 발전할 수 있습니다.</p>
        </div>
        <p>성취 이력은 개인 페이지 내 수상 등록으로 입력할 수 있어요.</p>
        <div className={isMobile ? 'mbtyes' : 'btyes'} id="herija">
        {last?.yoso?.map((cons,i)=>{
                    const kdk = `/hika/${cons.sun}`; 
                    const dayr = cons.date; 
            
                  
                    return(
                        <div className={isMobile ? 'mpytes' : 'spytes'}>
                            <Link to={kdk} className={isMobile ? 'ouno mnot' : 'ouno ynot'} state={cons} onClick={()=>{window.history.replaceState({page : single, molan : arum},null,null); 
                        window.history.ates = {page : single, nnnn : window.scrollY};}}>
                             <p className='urong'>{cons.name}</p>
                            <p className='urong tiuro'>{cons.title}</p>
                            <p className='urong'>{cons.prize}</p>
                            <p className='urong'>{dayjs(dayr).format('YY-MM-DD')}</p>
                            {/* <p className='urong'>HIT {cons.hit}</p> */}
                            </Link>
                        </div>
                    );
                })}
        </div>
        {isMobile ? 
     <div className='badaku'>
        {addnum >1 && <button onClick={minusnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssleft.png'} className='yulll'/></button>}
        {last?.zonche /100 >= addnum ? Array.from({length : 10},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
            return(<button onClick={()=>{yidong(cons);}} className="aisu">{cons}</button> );}) : Array.from({length : Math.ceil((last?.zonche%100)/10)},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
              
                return(<button onClick={()=>{yidong(cons);}} className={`aisu ${single == cons ? "yahii" : ""}`}>{cons}</button> );})}
        {last?.zonche > addnum*100 && <button onClick={addnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssright.png'} className='yurrr'/></button>}
     </div>
     : 
     <div className='badaku'>
        {addnum >1 && <button onClick={minusnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssleft.png'} className='yulll'/></button>}
        {last?.zonche /90 >= addnum ? Array.from({length : 10},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
          return(<button onClick={()=>{yidong(cons);}} className="aisu">{cons}</button> );}) : Array.from({length : Math.ceil((last?.zonche%90)/9)},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
            
              return(<button onClick={()=>{yidong(cons);}} className={`aisu ${single == cons ? "yahii" : ""}`}>{cons}</button> );})}
        {last?.zonche > addnum*90 && <button onClick={addnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssright.png'} className='yurrr'/></button>}
     </div>   
        }
        </>
    )

}

export default Hizan;